var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-login" }, [
    _c("div", { staticClass: "page-login--layer page-login--layer-area" }, [
      _c(
        "ul",
        { staticClass: "circles" },
        _vm._l(10, function(n) {
          return _c("li", { key: n })
        }),
        0
      )
    ]),
    _c(
      "div",
      {
        staticClass: "page-login--layer page-login--layer-time",
        attrs: { flex: "main:center cross:center" }
      },
      [_vm._v(" " + _vm._s(_vm.time) + " ")]
    ),
    _c(
      "div",
      {
        staticClass: "page-login--content-main",
        attrs: { flex: "dir:top main:center cross:center" }
      },
      [
        _c("img", {
          staticClass: "page-login--logo",
          attrs: { src: require("@/assets/images/logo.fbefbe23.png") }
        }),
        _c("span", { staticClass: "title" }, [_vm._v("产品管理后台")]),
        _c(
          "div",
          { staticClass: "page-login--form" },
          [
            _c(
              "el-card",
              { attrs: { shadow: "never" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "loginForm",
                    attrs: {
                      "label-position": "top",
                      rules: _vm.rules,
                      model: _vm.formLogin,
                      size: "default"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "account" } },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: { type: "text", placeholder: "用户名" },
                            model: {
                              value: _vm.formLogin.email,
                              callback: function($$v) {
                                _vm.$set(_vm.formLogin, "email", $$v)
                              },
                              expression: "formLogin.email"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-user-circle-o",
                              attrs: { slot: "prepend" },
                              slot: "prepend"
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "passwd" } },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: { type: "password", placeholder: "密码" },
                            model: {
                              value: _vm.formLogin.password,
                              callback: function($$v) {
                                _vm.$set(_vm.formLogin, "password", $$v)
                              },
                              expression: "formLogin.password"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-keyboard-o",
                              attrs: { slot: "prepend" },
                              slot: "prepend"
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "button-login",
                        attrs: { size: "default", type: "primary" },
                        on: { click: _vm.submit }
                      },
                      [_vm._v(" 登录 ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }